import { Dialog } from "construct-ui";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import languageModel from "../../models/language.model";
import ModelManagementModel from "../../models/model-management/model-management.model";
import ViewBase from "../view-base.view";

/**
 * Model UDF Data Definition dialog
 * 
 * 
 * 
 * @author cmc.nttruong1
 */

export default function ModelUdfDataDefinitionDialog() {

  ViewBase.call(this);

  const LIST_VALUE_TYPE = 'LIST_VALUE';

  let modelUDFDataBeforeUpdate = [];
  let modelUDFData = [];

  const getModelById = (modelCode) => {
    ModelManagementModel.getModelUDFDataDetails(modelCode)
      .then((result) => {
        modelUDFData = result.map((item) => Object.assign({
          ...item, codeList: _formatCodeList(item.codeList)
        }));
        modelUDFDataBeforeUpdate = structuredClone(modelUDFData);
      })
      .catch((error) => { this.handleError(error); })
  }

  const _formatCodeList = (codeList) => {
    return codeList.map((item) => Object.assign({ code: item.stdid, name: item.stdvalue, sequence: 0 }));
  }

  const hasChanges = () => {
    for (const i in modelUDFData) {
      if (JSON.stringify(modelUDFData[i]) !== JSON.stringify(modelUDFDataBeforeUpdate[i])) {
        return true;
      }
    }
    return false;
  }

  const _toQueryParams = (params) => {
    return params.filter((item) => item.editable).map((item) =>
      Object.assign({
        id: item.udfID,
        value: item.value ?? ""
      }));
  };

  const _onClose = (closeCallback) => {
    if (hasChanges() && confirm(this.getText('EM00000776', 'Changes you made may not be saved'))) {
      closeCallback();
    }
    if (!hasChanges()) { closeCallback(); }
  }

  const _onSave = (modelCode, saveCallback) => {
    this.showLoading();
    ModelManagementModel.updateModelUDFData(modelCode, _toQueryParams(modelUDFData))
      .then(saveCallback)
      .catch((error) => { this.handleError(error); })
      .finally(() => { this.hideLoading(); })
  }

  return {
    oninit: (vnode) => {
      getModelById(vnode.attrs.modelCode);
    },
    view: (vnode) => m(Dialog, {
      isOpen: true,
      closeOnOutsideClick: false,
      closeOnEscapeKey: true,
      onClose: () => _onClose(vnode.attrs.onClose),
      title: languageModel.getText('LT00000962', 'Model UDF Data - Definition'),
      content: m('.card',
        m('.card-body.d-grid.gap-2',
          modelUDFData.map((data) => {
            return m('.row',
              m('.col-3.pt-2', this.getText('', data.attributeName)),// this label is dynamic
              m('.col-9',
                data.attributeType !== LIST_VALUE_TYPE
                  ? m('input.form-control', {
                    disabled: !data.editable,
                    value: data.value,
                    oninput: (e) => { data.value = e.target.value; }
                  })
                  : m(SingleSelectComponent, {
                    disabled: !data.editable,
                    keyOnly: true,
                    items: data.codeList,
                    selectedItem: data.value,
                    onSelect: (s) => {
                      data.value = s;
                    }
                  }),
                m('i.form-text', data.description)
              ),
            )
          }),
        )
      ),
      footer: m('.d-flex.justify-content-end.gap-2',
        m('button.btn.btn-primary', { onclick: () => _onSave(vnode.attrs.modelCode, vnode.attrs.onSaveComplete) }, languageModel.getText('LT00000022', 'Save')),
        m('button.btn.btn-white', { onclick: () => _onClose(vnode.attrs.onClose) }, languageModel.getText('LT00000021', 'Close'))
      )
    })
  }
}